

export const fetchCityList = async (request, setter) => {
  try {
    const response = await request(
      "GET",
      `/v1/survey/locations/city-profile`,
      {},
      "survey_service"
    );
    setter(response);
  } catch (error) {
    console.log(error);
  }
};

export const fetchLocationWiseSurveyandYearList = async (
  request,
  locationid,
  setter
) => {
  if (!locationid) {
    return [];
  }
  try {
    const response = await request(
      "GET",
      `/v1/survey/city-profile/${locationid}`,
      {},
      "survey_service"
    );

    setter && setter(response.surveys || []);
    return response?.surveys || [];
  } catch (error) {
    console.log(error);
  }
};

export const fetchIMISurveyList = async (request, cityName, setter) => {
  try {
    if (!cityName) {
      return [];
    }
    const response = await request(
      "GET",
      `/v1/imis/indicators/city-profile/${cityName}`,
      {},
      "external_service"
    );

    setter && setter(response.surveys || []);
    return response?.surveys || [];
  } catch (error) {
    console.log(error);
    return []
  }
};

export const fetchAllSurveyList = async (request, setter) => {
  try {
    const response = await request(
      "GET",
      `/v1/survey/list?status=COMPLETED&offset=0&limit=100`,
      {},
      "survey_service"
    );

    setter &&
      setter(
        [...response.content].map((item) => ({
          ...item,
          year: new Date(item.endDate).getFullYear(),
        }))
      );
    return [...response.content].map((item) => ({
      ...item,
      year: new Date(item.endDate).getFullYear(),
    }));
  } catch (error) {
    console.log(error);
  }
};

// function getFlatUpazilaArray(data) {
//   let flatArray = [];
//   data.forEach((division) => {
//     division.district.forEach((district) => {
//       if (district.upazila && district.upazila.length > 0) {
//         flatArray = flatArray.concat(district.upazila);
//       }
//     });
//   });
//   return flatArray;
// }


export const fetchMapData = async (request, cityId,  surveyId) => {
  try {

    if (!cityId || !surveyId) {

      return [];
    }
    const data = await request(
      "GET",
      `/v1/survey/dashboard/wards?location=${cityId}&survey=${surveyId}`,
      {},
      "survey_service"
    );

    if (data?.city) {
      
      const processedPoints = data.city?.flatMap((collection, collectionIndex) =>
        collection.features.map((feature, featureIndex) => {
          const geometry = feature.geometry;
          return {
            id: `${collectionIndex}-${featureIndex}`,
            feature: feature.properties.feature,
            type: feature.properties.type,
            lat: geometry.coordinates[1],
            lng: geometry.coordinates[0],
            pointType: feature.properties.type
              ? `${feature.properties.feature}-${feature.properties.type}`
              : feature.properties.feature,
          };
        })
      );

      return {
        city: processedPoints || [],
        wards: data?.wards || [],
      };
    }

    return {
      city: [],
      wards: [],
    };

  } catch (error) {
    console.error('Error fetching map data:', error);
    return {
      city: [],
      wards: [],
    };
  }
};
